import { ROLES } from '../../../utils/roles.js';
import { M } from '../msg.js';
import { registerPageTour } from '../matchRoute.js';

const PROFILE_PATHS = ['/admin/profile', '/my/profile', '/super-admin/profile'];

registerPageTour({
  id: 'profile',
  match: (p) => PROFILE_PATHS.includes(p),
  steps: [
    {
      id: 'intro',
      selector: '[data-tour="page-title"]',
      title: M('Profile settings', 'Настройки профиля'),
      body: M(
        'Your personal account: name, email, password, interface language, and notification preferences.',
        'Личный аккаунт: имя, email, пароль, язык интерфейса и уведомления.',
      ),
      roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.TEAM_MEMBER, ROLES.CLIENT],
    },
    {
      id: 'details',
      selector: '[data-tour="profile-details"]',
      title: M('Account details', 'Данные аккаунта'),
      body: M(
        'Update display name and email. Email changes may require verification depending on agency policy.',
        'Имя и email. Смена email может требовать верификации.',
      ),
      roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.TEAM_MEMBER, ROLES.CLIENT],
    },
    {
      id: 'language',
      selector: '[data-tour="profile-language"]',
      title: M('Interface language', 'Язык интерфейса'),
      body: M(
        'Choose English, Russian, Spanish, French, Chinese, or Hindi. Saves with profile and applies to tours and menus.',
        'English, русский, español, français, 中文, हिन्दी. Сохраняется с профилем — меню и обучение.',
      ),
      roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.TEAM_MEMBER, ROLES.CLIENT],
    },
    {
      id: 'onboarding',
      selector: '[data-tour="profile-onboarding"]',
      title: M('Tour prompts', 'Подсказки обучения'),
      body: M(
        'Turn off automatic tour offers if you already know the portal. Use the ? Tour button anytime to replay a guide.',
        'Отключите автоматические предложения обучения. Кнопка «? Обучение» всегда запускает тур вручную.',
      ),
      roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.TEAM_MEMBER, ROLES.CLIENT],
    },
    {
      id: 'password',
      selector: '[data-tour="profile-password"]',
      title: M('Password', 'Пароль'),
      body: M(
        'Change password with current password confirmation. Use a strong unique password for portal access.',
        'Смена пароля с подтверждением текущего. Используйте надёжный уникальный пароль.',
      ),
      roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.TEAM_MEMBER, ROLES.CLIENT],
    },
    {
      id: 'notifications',
      selector: '[data-tour="profile-notifications"]',
      title: M('Notifications', 'Уведомления'),
      body: M(
        'Choose which events send email or push. In-app alerts always appear in the bell icon.',
        'Какие события — email или push. In-app всегда в колокольчике.',
      ),
      roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.TEAM_MEMBER, ROLES.CLIENT],
    },
  ],
});
